import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISkillmemory } from "../../../Pages/Skillstrainer/ISkill";

export const AddMemoryGameSkillSlice = createSlice({
  name: "AddMemoryGameSkillSlice",
  initialState: {} as IReduxState<ISkillmemory>,
  reducers: {
    addMemoryGameSkill: (state, _: PayloadAction<ISkillmemory>) => {
      state.isLoading = true;
    },
    successaddMemoryGameSkill: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddMemoryGameSkill: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddMemoryGameSkillResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  addMemoryGameSkill,
  clearAddMemoryGameSkillResponse,
  successaddMemoryGameSkill,
  failureaddMemoryGameSkill,
} = AddMemoryGameSkillSlice.actions;

export default AddMemoryGameSkillSlice.reducer;
